export default __webpack_public_path__ + "images/openvoice-0b74413dad967334703b9a7d4442ba0a.svg";